(function () {
  const UTM_STORAGE_KEY = 'bm_utm';
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function captureUtm() {
    try {
      const params = new URLSearchParams(window.location.search);
      const found = {};
      let hasAny = false;
      UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) {
          found[key] = value;
          hasAny = true;
        }
      });
      // Only write when this page load actually carries UTM params, so we don't
      // clobber the original landing attribution on later internal navigation.
      if (hasAny) sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(found));
    } catch (e) {}
  }

  function readStoredUtm() {
    try {
      const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function makeEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `ls-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  function buildCheckoutUrl(baseUrl, { eventId, productId, sourceUrl }) {
    let url;
    try {
      url = new URL(baseUrl);
    } catch (e) {
      return null;
    }
    url.searchParams.set('checkout[custom][event_id]', eventId);
    if (productId) url.searchParams.set('checkout[custom][shopify_product_id]', productId);
    if (sourceUrl) url.searchParams.set('checkout[custom][source_url]', sourceUrl);

    const utm = readStoredUtm();
    Object.keys(utm).forEach((key) => {
      url.searchParams.set(`checkout[custom][${key}]`, utm[key]);
    });

    return url.toString();
  }

  function fireClientPixels(eventId, valueUsd) {
    try {
      if (typeof fbq === 'function') {
        fbq('track', 'Purchase', { value: valueUsd, currency: 'USD' }, { eventID: eventId });
      }
    } catch (e) {}
    try {
      if (typeof ttq === 'object' && ttq && typeof ttq.track === 'function') {
        ttq.track('CompletePayment', { value: valueUsd, currency: 'USD' }, { event_id: eventId });
      }
    } catch (e) {}
  }

  function initLemonSqueezy() {
    if (typeof window.createLemonSqueezy !== 'function') return;

    window.createLemonSqueezy();

    if (window.LemonSqueezy && typeof window.LemonSqueezy.Setup === 'function') {
      window.LemonSqueezy.Setup({
        eventHandler: (event) => {
          if (event.event !== 'Checkout.Success') return;
          const order = event.data && event.data.data ? event.data.data : {};
          // custom_data may or may not be echoed on the client payload; the
          // click-time event_id is the reliable fallback either way, and the
          // server-side webhook (source of truth for value/currency) always
          // has it via meta.custom_data regardless of what happens here.
          const eventId = (order.custom_data && order.custom_data.event_id) || window.__bmLastLemonSqueezyEventId;
          const valueUsd = order.total ? order.total / 100 : undefined;
          fireClientPixels(eventId, valueUsd);
          if (typeof window.bmShowToast === 'function') {
            window.bmShowToast('Thanks! Check your email for your download.');
          }
        },
      });
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bm-lemonsqueezy-buy]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.disabled) return;

    const baseUrl = trigger.getAttribute('data-lemonsqueezy-checkout-url');
    if (!baseUrl) return;

    const eventId = makeEventId();
    window.__bmLastLemonSqueezyEventId = eventId;

    const url = buildCheckoutUrl(baseUrl, {
      eventId,
      productId: trigger.getAttribute('data-product-id'),
      sourceUrl: window.location.href,
    });
    if (!url) return;

    if (window.LemonSqueezy && window.LemonSqueezy.Url && typeof window.LemonSqueezy.Url.Open === 'function') {
      window.LemonSqueezy.Url.Open(url);
    } else {
      // Lemon.js failed to load — fail safe by opening the hosted checkout in a
      // new tab rather than silently doing nothing or falling back to Shopify
      // checkout (which would charge in EGP, not USD).
      window.open(url, '_blank', 'noopener');
    }
  });

  captureUtm();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLemonSqueezy);
  } else {
    initLemonSqueezy();
  }
})();
